import { FC } from "react";
import { Avatar, styled } from "@mui/material";
import { PriorityHigh } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";

import type { ComplianceStatus } from "src/shared/api-types/certificate";
import { CertificateStatusType } from "src/services/certificateStatus";

const DaysSpan = styled("span")(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: "bold",
}));

export interface CourseRemainingDaysIconProps {
  status?: ComplianceStatus | null;
  days?: number | null;
  purchaseAction?: () => void;
}

const CourseRemainingDaysIcon: FC<CourseRemainingDaysIconProps> = ({ status, days, purchaseAction }) => {
  if (!status) return <div style={{ width: 20, height: 20 }} />;

  const renderAvatar = (bgcolor: string, content: React.ReactNode) => (
    <Avatar
      sx={{
        bgcolor,
        cursor: purchaseAction ? "cell" : "pointer",
      }}
      onClick={purchaseAction}
    >
      {content}
    </Avatar>
  );

  if (status === CertificateStatusType.EXPIRED) {
    return renderAvatar("red", <PriorityHigh />);
  } else if (status === CertificateStatusType.MISSING) {
    return renderAvatar("red", <DaysSpan>&nbsp;</DaysSpan>);
  } else if (status === CertificateStatusType.BUFFER) {
    return renderAvatar("#ffbf00", <DaysSpan>{days || ""}</DaysSpan>);
  } else if (status === CertificateStatusType.NEVER_EXPIRE) {
    return renderAvatar("green", <CheckIcon />);
  } else if (status === CertificateStatusType.OK) {
    return renderAvatar("green", <DaysSpan>{days}</DaysSpan>);
  }

  return null;
};

export default CourseRemainingDaysIcon;
